import { useSaveToDesignBoard } from '~/modules/design-board';
// import { useVariantSelectionState } from '../context/VariantSelectionContext';

export const useFavouriteVariant = (productID: number) => {
    // const { selectedVariant } = useVariantSelectionState();

    // TODO: Seems to not do anything, remove?
    // const urlSearchParams =
    //     productID && selectedVariant?.SKU
    //         ? new URLSearchParams({
    //               sku: selectedVariant.SKU,
    //           })
    //         : undefined;

    const { favouriteItem } = useSaveToDesignBoard({
        itemType: 'ProductPin',
        itemId: productID,
    });

    return favouriteItem;
};
